import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, Row, Col } from "reactstrap";

const CreateMomentoModal = ({ setMomentoSize, setPurchaseMemento }) => {
    const [modal, setModal] = useState(false);

    const toggle = () => {
        setModal(!modal);
        setPurchaseMemento(false);
    };
    return (
        <>
            <Button color="primary" onClick={toggle}>
                Select Size
            </Button>
            <Modal isOpen={modal} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                    Select the size of memento
                </ModalHeader>
                <ModalBody>
                    <Row className="mx-3 justify-content-between">
                        <Col
                            className="cursor-pointer border d-flex justify-content-center col-5 py-3"
                            onClick={() => {
                                setMomentoSize(11);
                                toggle();
                            }}
                        >
                            8.5 x 11
                        </Col>
                        <Col
                            className="cursor-pointer border d-flex justify-content-center col-5 py-3"
                            onClick={() => {
                                setMomentoSize(14);
                                toggle();
                            }}
                        >
                            8.5 x 14
                        </Col>
                    </Row>
                </ModalBody>
                {/* <ModalFooter>
                    <Button color="primary">Do Something</Button>{" "}
                    <Button color="secondary" onClick={toggle}>
                        Cancel
                    </Button>
                </ModalFooter> */}
            </Modal>
        </>
    );
};

export default CreateMomentoModal;
